export enum RESOURCE {
  ONBOARDING = 'ONBOARDING',
  SEARCH = 'SEARCH',
}

export const RESOURCE_NAME: Record<RESOURCE, string | undefined> = {
  [RESOURCE.ONBOARDING]: 'Onboarding',
  [RESOURCE.SEARCH]: 'Search',
};

export const ALL_RESOURCE = Object.entries(RESOURCE).map(([key, value]) => value);
